import config from '@/config'

export default {
  makeDefaultRequestData: () => {
    return {
      baseUrl: config.VUE_APP_API_URL,
    };
  },
  makeUserManagerRequestData: () => {
    return {
      baseUrl: '',
      headers: {
        authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }
  },
  loadBaseUrl() {
    return config.VUE_APP_API_URL
  },
  loadNewBaseUrl() {
      return config.VUE_APP_NEWAPI_URL
  },
  getCountryConfig() {
    return config.countries[config.VUE_APP_COUNTRY] ?? {}
  },
  
  loadUserId() {
      let account = this.loadLocalStorage();
      return account.userId;
  },

  loadCountry() {
      let account = this.loadLocalStorage();
      return account.country;
  },

  loadaud(){
    let account = this.loadLocalStorage();
      return account.aud;
  },

  loadToken() {
    let token = localStorage.getItem('msal.' + this.loadaud() + '.idtoken');
    return token;
  },

  loadLocalStorage() {
      let account = JSON.parse(localStorage.getItem('msal.custom'));
      if (!account) {
          account = { country: "", userId: "" };
      }
      return account;
  },
}
